import { createReducer, on } from '@ngrx/store';
import { cloneDeep } from 'lodash';
import { ReportViewTraitResultActions } from './result.actions';
import {
  ReportViewTraitResultState,
  initialReportViewTraitResultState,
  reportViewTraitResultState
} from './result.state';

export const reportViewTraitResultReducer = createReducer(
  reportViewTraitResultState,
  on(
    ReportViewTraitResultActions.reset,
    (): ReportViewTraitResultState =>
      cloneDeep(initialReportViewTraitResultState)
  ),
  on(
    ReportViewTraitResultActions.setReport,
    (state, report): ReportViewTraitResultState => ({
      ...state,
      report
    })
  ),
  on(
    ReportViewTraitResultActions.setLoading,
    (state, { loading }): ReportViewTraitResultState => ({
      ...state,
      loading
    })
  )
);
